import { ChatView } from './chat/components/chat-view';
import { TooltipProvider } from './components/ui/tooltip';
import { MainLayout } from './layout/components/main-layout';

function App() {
  return (
    <TooltipProvider>
      <MainLayout>
        <ChatView />
      </MainLayout>
    </TooltipProvider>
  );
}

export default App;
